import React, { FC } from "react";
import { BaseLayout } from "layouts/BaseLayout";
import { Footer } from "components/Footer/footer";
import { trimLeadingAndTrailingSlashes } from "helpers/trimChars";

interface AutoLayoutProps {
    path: string;

    canonical?: string;
    description?: string;
    footerMiddleSection?: JSX.Element;
    pageName?: string;
    pageType?: string;
    title?: string;
    heroImage?: string;
    googleSearchConsole?: string;
    faceBookPixel?: string;
}

export const AutoLayout: FC<AutoLayoutProps> = ({
    canonical,
    title,
    description,
    footerMiddleSection,
    path = "",
    children,
    pageName,
    pageType,
    heroImage,
    googleSearchConsole,
    faceBookPixel
}) => {
    const canonicalUrl =
        canonical || `https://www.autotrack.nl/${trimLeadingAndTrailingSlashes(path.trim())}`;

    return (
        <BaseLayout
            title={title}
            description={description}
            canonicalUrl={canonicalUrl}
            pageName={pageName}
            pageType={pageType}
            googleAnalyticsId="UA-2448665-1"
            heroImage={heroImage}
            googleSearchConsole={googleSearchConsole}
            faceBookPixel={faceBookPixel}
        >
            {children}
            <Footer middleSection={footerMiddleSection} />
        </BaseLayout>
    );
};

AutoLayout.defaultProps = {};
AutoLayout.displayName = "AutoLayout";
